import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7522371c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "floating-menu"
}
const _hoisted_2 = { class: "text-center" }

import store from '@/store'
import { useRoute, useRouter } from 'vue-router'
import AuthorizationView from '@/components/AuthorizationView.vue'
import cookieToken from '@/store/cookieToken'
import MainMenu from '@/components/MainMenu.vue'
import UserInfo from '@/components/UserInfo.vue'
import NotificationListener from '@/components/chat/NotificationListener.vue'
import { ref, watch } from 'vue'
import { Menu as MenuIcon } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const menuOpened = ref(false)
watch(() => menuOpened.value, () => {
  if (menuOpened.value) {
    document.body.classList.add('scroll-disable')
  } else {
    document.body.classList.remove('scroll-disable')
  }
})
watch(() => router.currentRoute.value, () => {
  menuOpened.value = false
})

const isLoaded = ref(false)

cookieToken.check().then(() => {
  isLoaded.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_footer = _resolveComponent("el-footer")!

  return (_unref(store).state.user)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_el_header, { class: "hidden-md-and-up header" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, { class: "header-container" }, {
              default: _withCtx(() => [
                _createVNode(UserInfo),
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (menuOpened.value = !menuOpened.value)),
                  type: menuOpened.value ? 'primary' : ''
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(MenuIcon))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["type"])
              ]),
              _: 1
            }),
            (menuOpened.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(MainMenu, {
                    onClose: _cache[1] || (_cache[1] = ($event: any) => (menuOpened.value = false))
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_aside, {
              width: "20%",
              class: "hidden-sm-and-down"
            }, {
              default: _withCtx(() => [
                _createVNode(UserInfo),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_scrollbar, null, {
                    default: _withCtx(() => [
                      _createVNode(MainMenu)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, {
              width: "80%",
              class: "el-main__custom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(NotificationListener)
      ], 64))
    : (['register-confirm', 'not-found', 'api-documentation'].includes(_unref(route).name))
      ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : (isLoaded.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(AuthorizationView),
            _createVNode(_component_el_footer, { class: "footer" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_link, { to: {name: 'api-documentation'} }, {
                    default: _withCtx(() => [
                      _createTextVNode("API документация")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
}
}

})